var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPinterestDesktopReact = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M8.017 2c1.156 0 2.249.256 3.242.709a7.5 7.5 0 0 0-.753 2.995A4.86 4.86 0 0 0 8.017 5C5.13 5 3 7.768 3 11c0 1.83 1.09 4.079 3.355 6.7l.266.303.379.427V21h3v-2.515l.568-.735c1.655-2.194 2.594-4.136 2.856-5.808a7.5 7.5 0 0 0 2.786 1.343c-.427 1.738-1.329 3.57-2.688 5.505l-.298.415-.224.3V24H4v-4.439l-.199-.233C1.482 16.563.202 13.994.022 11.587l-.017-.3L0 11c0-4.742 3.275-9 8.017-9M18 0a6 6 0 1 1 0 12 6 6 0 0 1 0-12m0 2.5a1 1 0 0 0-.993.883L17 3.5V5h-1.5a1 1 0 0 0-.117 1.993L15.5 7H17v1.5a1 1 0 0 0 1.993.117L19 8.5V7h1.5a1 1 0 0 0 .117-1.993L20.5 5H19V3.5a1 1 0 0 0-1-1"
})));
export default SvgPinterestDesktopReact;